import { useState } from "react";
import { SearchFiltersModal } from "../shared/searchFiltersModal";

export const PayDisplayMachinesFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialPayDisplayFilterStatus,
	initialAppliedFilters
}) => {
	const [payDisplayFilterStatus, setPayDisplayFilterStatus] = useState(initialPayDisplayFilterStatus)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setPayDisplayFilterStatus(null)
		setAppliedFilters(null)
	}

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ payDisplayFilterStatus, appliedFilters }) }
			showModal={ showModal }
			key="pay-display-machines-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Status</label>
					<select
						value={ payDisplayFilterStatus === true ? "true" : payDisplayFilterStatus === false ? "false" : "" }
						onChange={ e => {
							const value = e.target.value === "true" ? true : e.target.value === "false" ? false : null
							setPayDisplayFilterStatus(value)
							setAppliedFilters(prevState => {
								const updatedFilters = { ...prevState }
								if (value === null) {
									delete updatedFilters["Status"]
								} else {
									updatedFilters["Status"] = value ? "Active" : "Deactivated"
								}
								return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
							})
						} }
						className="border rounded px-2 py-1 w-100"
					>
						<option value="">All</option>
						<option value="true">Active</option>
						<option value="false">Deactivated</option>
					</select>
				</div>
			</div>
		</SearchFiltersModal>
	)
}
